// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + "bf5f3635" + "." + "a56adbefe04a80c5" + ".js";
};